import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const containerHeaderCss = ".container-header{color:var(--hmc-color-content-default, var(--hmc-color-gray-black, #101820));display:flex;align-items:flex-start;width:100%;align-self:stretch;padding-top:2px;padding-bottom:15px}.container-header.high-density{padding-top:4px;padding-bottom:12px}.container-header.high-density .heading{font-size:var(--font-size-medium, 16px);line-height:24px;font-weight:700}.container-header.high-density .subtitle{font-size:12px;line-height:16px}.container-header.high-density .icon-wrapper{padding-top:0px}.container-header.low-density{padding-bottom:18px}.container-header.low-density .heading{font-size:24px;line-height:32px}.container-header.low-density .subtitle{font-size:var(--font-size-medium, 16px);line-height:24px}.container-header.low-density .icon-wrapper{padding-top:4px}.icon-wrapper{padding-top:2px}::slotted(*){padding-right:8px}.title-group{display:flex;font-family:var(--font-family-body, \"Inter\", sans-serif);flex-direction:column;align-items:flex-start;align-self:stretch}.heading{display:flex;justify-content:space-between;align-items:center;text-align:left;margin:0;font-size:20px;line-height:28px;font-weight:600;color:var(--hmc-color-content-default, var(--hmc-color-gray-black, #101820))}.subtitle{color:var(--hmc-color-content-subtle, var(--hmc-color-gray-700, #5e6773));font-weight:400;font-size:14px;line-height:20px}";

const HmcContainerHeader$1 = /*@__PURE__*/ proxyCustomElement(class HmcContainerHeader extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.density = 'medium';
    this.heading = '';
    this.subtitle = '';
  }
  render() {
    const { density, heading, subtitle } = this;
    const classList = {
      'container-header': true,
      'high-density': density === 'high',
      'low-density': density === 'low',
    };
    return (h(Host, null, h("div", { class: classList }, h("div", { class: "icon-wrapper" }, h("slot", { name: "icon" })), h("div", { class: "title-group" }, h("div", { class: "heading" }, heading), h("div", { class: "subtitle" }, subtitle)))));
  }
  static get style() { return containerHeaderCss; }
}, [1, "hmc-container-header", {
    "density": [1],
    "heading": [1],
    "subtitle": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["hmc-container-header"];
  components.forEach(tagName => { switch (tagName) {
    case "hmc-container-header":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, HmcContainerHeader$1);
      }
      break;
  } });
}

const HmcContainerHeader = HmcContainerHeader$1;
const defineCustomElement = defineCustomElement$1;

export { HmcContainerHeader, defineCustomElement };
